import React from 'react';
import { ShieldCheck, UserCheck, Leaf, Award, Star, Clock } from 'lucide-react';
import { useT } from '../i18n/LanguageContext';

export default function TrustBadges() {
  const { t } = useT();

  const badges = [
    { icon: ShieldCheck, title: t('trust.1.title'), desc: t('trust.1.desc') },
    { icon: UserCheck, title: t('trust.2.title'), desc: t('trust.2.desc') },
    { icon: Leaf, title: t('trust.3.title'), desc: t('trust.3.desc') },
    { icon: Award, title: t('trust.4.title'), desc: t('trust.4.desc') },
    { icon: Star, title: t('trust.5.title'), desc: t('trust.5.desc') },
    { icon: Clock, title: t('trust.6.title'), desc: t('trust.6.desc') },
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-12">
          <p className="uc-kicker mb-3">{t('trust.kicker')}</p>
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-[#1a2851]">
            {t('trust.heading')}
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          {badges.map((b, i) => {
            const Icon = b.icon;
            return (
              <div
                key={i}
                className="uc-lift text-center p-5 rounded-xl bg-[#f7fcfb] border border-[#eef6f4]"
              >
                <div className="w-14 h-14 mx-auto rounded-full bg-white border-2 border-[#4dbfae] flex items-center justify-center mb-3 text-[#4dbfae]">
                  <Icon size={22} />
                </div>
                <p className="font-semibold text-[#1a2851] text-sm mb-1">{b.title}</p>
                <p className="text-xs text-[#5b6469] leading-relaxed">{b.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
